import { createFileRoute } from "@tanstack/react-router";

import AccountNew from "@/components/[routes]/accounts/accounts-new";

export const Route = createFileRoute("/_secure/accounts/new")({
  component: AccountNew,
});
